import { createAction } from 'redux-actions';
import { authFetch } from '../AuthFetch';

export const changeSearchEventKey = createAction('CHANGE_SEARCH_EVENT_KEY');
export const cleanSearchEpcAlert = createAction('CLEAN_SEARCH_EPC_ALERT');

export const findSearchEpcList = (payload) => (
  (dispatch) => {
    let searchEpcInput = payload.searchEpcInput;
    let searchLabelIdInput = payload.searchLabelIdInput;
    let searchBagBarcodeInput = payload.searchBagBarcodeInput;
    let searchOrdererNameInput = payload.searchOrdererNameInput;
    let searchOrderIdInput = payload.searchOrderIdInput;

    let url = '/firefighter/search/searchByEpc?';
    if (searchEpcInput) {
      url += 'epc=' + searchEpcInput;
    }
    else if (searchLabelIdInput) {
      url += 'labelId=' + searchLabelIdInput;
    }
    else if (searchBagBarcodeInput) {
      url += 'bagBarcode=' + searchBagBarcodeInput;
    }
    else if (searchOrdererNameInput) {
      url += 'ordererName=' + searchOrdererNameInput;
      if (searchOrderIdInput) {
        url += '&orderId=' + searchOrderIdInput;
      }
    }
    authFetch('GET', url, null, (json) => {
      dispatch({
        type: 'FIND_SEARCH_EPC_LIST',
        payload: json
      });
    });
  }
);

export const findSearchMRecordList = (payload) => (
  (dispatch) => {
    let url = '/firefighter/search/searchMaintenenceRecordByEpc?epc=' + payload;
    authFetch('GET', url, null, (json) => {
      dispatch({
        type: 'FIND_SEARCH_M_RECORD_LIST',
        payload: json
      });
    });
  }
);

export const openSearchMRecordModal = createAction('OPEN_SEARCH_M_RECORD_MODAL');
export const closeSearchMRecordModal = createAction('CLOSE_SEARCH_M_RECORD_MODAL');

export const findMRecordDetail = (payload) => (
  (dispatch) => {
    let url = '/firefighter/search/searchMRecordDetail/cardId/'+ payload.card_id +'/type/' + payload.cat;
    authFetch('GET', url, null, (json) => {
      dispatch({
        type: 'FIND_SEARCH_M_RECORD_DETAIL',
        payload: json
      });
    });
  }
);

export const cleanSearchEpclList = createAction('CLEAN_SEARCH_EPC_LIST');
export const cleanSearchMRecordList = createAction('CLEAN_SEARCH_M_RECORD_LIST');

export const findSearchEpcListByReadEpc = (speedway) => (
  (dispatch) => {

    dispatch({
      type: 'LOADING_SEARCH_CHIP_EPCS'
    });

    let url = '/firefighter/search/searchByReadEpc';
    authFetch('POST', url, JSON.stringify(speedway), (json) => {
      dispatch({
        type: 'FIND_SEARCH_EPC_LIST',
        payload: json
      });
    });
  }
);

export const findSearchEpcCheck = (payload) => (
  (dispatch) => {
    let searchEpcInput = payload.searchEpcInput;

    let url = '/firefighter/search/searchEpcCheck?epc=' + searchEpcInput;

    authFetch('GET', url, null, (json) => {
      dispatch({
        type: 'FIND_SEARCH_EPC_CHECK',
        payload: json
      });
    });
  }
);


// WEBPACK FOOTER //
// ./src/actions/searchActions.js